import { Modal, Text } from '@thefarmersfront/kitchen';

import { ResultStatusSummary, Table } from '~/components/common';

import { useUserInfoStore } from '~/store';
import { getReceiveExcelUploadFailModalColumnDefs } from '~/utils';

import type { TypePostRequestGoodsUploadResponse } from '~/types/receive.types';

import styles from './ReceiveRequestExcelUploadFailModal.module.scss';

type TypeReceiveRequestExcelUploadFailModalProps = {
  data: TypePostRequestGoodsUploadResponse;
  open: boolean;
  onConfirm: () => void;
};

/**
 * [입고관리 > 입고요청관리] 입고요청등록모달 > 엑셀 추가 실패 모달
 */
const ReceiveRequestExcelUploadFailModal = ({ data, open, onConfirm }: TypeReceiveRequestExcelUploadFailModalProps) => {
  const { totalCount, successCount, failCount, failItems } = data;

  const hasPermission = useUserInfoStore((state) => state.hasPermission);
  const hasPermissionNFA = hasPermission([{ ownerType: 'NFA' }]);

  const { columnDefs } = getReceiveExcelUploadFailModalColumnDefs({
    data: failItems,
    hasPermissionNFA,
  });

  return (
    <Modal title="엑셀 추가 실패" size="large" open={open} onConfirm={onConfirm}>
      <div className={styles['contents-container']}>
        <ResultStatusSummary totalCount={totalCount} successCount={successCount} failCount={failCount} />
        <div className={styles['fail-items-section']}>
          <Text size="large" weight="semi-bold">
            업로드 실패 내역
          </Text>
          <div className={styles['table-wrapper']}>
            <Table className={styles['table']} data={failItems} options={{ columnDefs }} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReceiveRequestExcelUploadFailModal;
